import { Controller } from 'stimulus'

import {
  removeAriaHiddenAllSiblings,
  setAriaHiddenAllSiblings
} from '../../common/dom-utils'

const openedClass = '-menuOpened'

export default class extends Controller {
  static get targets() {
    return ['button', 'menu', 'close']
  }

  initialize() {
    if (this.firstOpened) {
      this.open();
    }
  }

  connect() {
    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.menuTarget.setAttribute('tabindex', '-1')

    this.tabbableElements = Array.from(
      this.menuTarget.querySelectorAll('a,button')
    )
  }

  get firstOpened() {
    return this.data.get('first-opened') === 'true'
  }

  get opened() {
    return this.data.get('opened') === 'true'
  }

  set opened(opened) {
    this.data.set('opened', String(opened))

    if (opened) {
      document.documentElement.classList.add(openedClass)
      this.element.classList.add(openedClass)
      this.buttonTarget.setAttribute('aria-expanded', 'true')
    } else {
      document.documentElement.classList.remove(openedClass)
      this.element.classList.remove(openedClass)
      this.buttonTarget.setAttribute('aria-expanded', 'false')
    }
  }

  open() {
    if (this.opened) {
      return
    }
    this.opened = true

    setAriaHiddenAllSiblings(this.menuTarget)

    // 表示されるのを一瞬まつ
    setTimeout(() => {
      this.focus(this.tabbableElements[0])
    }, 100)
  }

  close() {
    if (!this.opened) {
      return
    }
    this.opened = false

    removeAriaHiddenAllSiblings(this.menuTarget)

    this.focus(this.buttonTarget)
  }

  handleKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc' /* IE 11 */) {
      this.close()
    } else if (e.key === 'Tab') {
      this.rollFocus(e.shiftKey)
      e.preventDefault()
    }
  }

  focus(element) {
    if (!element) {
      return
    }
    element.focus()
  }

  rollFocus(backFlag) {
    let focusIndex
    const currentIndex = this.tabbableElements.indexOf(document.activeElement)
    if (currentIndex < 0) {
      focusIndex = 0
    } else {
      const tabbableLength = this.tabbableElements.length
      const direction = backFlag ? -1 : 1
      focusIndex = (currentIndex + direction + tabbableLength) % tabbableLength
    }
    this.focus(this.tabbableElements[focusIndex])
  }
}
